import Vue from 'vue'
import Vuex from 'vuex'
import user from './user.js'

Vue.use(Vuex)
 

// "admin",
// "generaladministrato",
// "nstitutionalteacher",
// "salespersonr",
// "outboundcall", 

export default new Vuex.Store({
  state: {
    openTab: [
    ], //所有打开的路由
    activeIndex: '', //激活状态
    $userInfo: {},
    $roleList: [],//角色列表
    asideList: [
      {
        name: "首页",
        index: "/home",
        icon: "el-icon-s-home", 
        roles: [
          "admin",
          "generaladministrato",
          "nstitutionalteacher",
          "salespersonr", 
          "outboundcall",  
        ],
      }, 
      {
        name: "学员管理",
        index: "/accountManage",
        icon: "el-icon-s-marketing",
        roles: [
          "admin",
          "generaladministrato",
          "nstitutionalteacher",
          "salespersonr", 
        ],
        children: [
          {
            name: "学员管理",
            index: "/studentManage",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher",
              "salespersonr", 
            ],
          },
          {
            name: "学员标签管理",
            index: "/labelManage",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher",
              "salespersonr", 
            ],
          },
          {
            name: "考生档案",
            index: "/senioriupUserList",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher",
              "salespersonr", 
            ],
          }, 
          {
            name: "学习数据统计",
            index: "/dataStatistics",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher",
              "salespersonr", 
            ],
          },
          {
            name: "开卡管理",
            index: "/cardManage",
            icon: "",
            roles: [ 
              "admin",
              "generaladministrato",  
            ],
          },
          {
            name: "数据导出中心",
            index: "/cardExportLog",
            icon: "",
            roles: [ 
              "admin",
              "generaladministrato",   
            ],
          }, 
        ],
      },
      {
        name: "商品管理",
        index: "/goodsManage",
        icon: "el-icon-s-shop",
        roles: [
          "admin",
          "generaladministrato",
          "nstitutionalteacher", 
        ],
        children1: [
          {
            name: "会员",
            index: "/memberManage",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher", 
            ],
          },
          {
            name: "课程管理",
            index: "/courseManage",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher", 
            ],
          }, 
          {
            name: "定制资料",
            index: "/customOrderList",
            icon: "",
            roles: [
              "admin",
              "generaladministrato", 
            ],
          },
          {
            name: "其它商品",
            index: "/bktOtherGoods",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher", 
            ],
          },
          {
            name: "套餐",
            index: "/setMealList",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher", 
            ],
          },
        ],
        children2: [
          {
            name: "高职单招",
            index: "/senioriup",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher",
              "salespersonr", 
            ],
            children:[ 
              {
                name: "会员",
                index: "/memberManage",
                icon: "",
                roles: [
                  "admin",
                  "generaladministrato",
                  "nstitutionalteacher",
                  "salespersonr", 
                ],
              },
              {
                name: "课程管理",
                index: "/courseManage",
                icon: "",
                roles: [
                  "admin",
                  "generaladministrato",
                  "nstitutionalteacher",
                  "salespersonr", 
                ],
              },
              {
                name: "定制资料",
                index: "/customOrderList",
                icon: "",
                roles: [
                  "admin",
                  "generaladministrato", 
                ],
              },
              {
                name: "其它商品",
                index: "/bktOtherGoods",
                icon: "",
                roles: [
                  "admin",
                  "generaladministrato",
                  "nstitutionalteacher", 
                ],
              },
            ]
          },
          {
            name: "成考",
            index: "/adultscollege",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher",
              "salespersonr", 
            ],
            children:[ 
              {
                name: "套餐",
                index: "/setMealList",
                icon: "",
                roles: [
                  "admin",
                  "generaladministrato",
                  "nstitutionalteacher",
                  "salespersonr", 
                ],
              },
            ]
          } 
        ],
      },   
      {
        name: "推广中心",
        index: "/extendManage",
        icon: "el-icon-s-claim",
        roles: [
          "admin",
          "generaladministrato",
          "nstitutionalteacher",
          "salespersonr", 
        ],
        children: [
          {
            name: "推广老师管理",
            index: "/extendTeachManage",
            icon: "",
            roles: [
              "admin",
              "generaladministrato", 
            ],
          },
          {
            name: "推广工具",
            index: "/extendTool",
            icon: "",
            roles: [
              "admin",
              "generaladministrato", 
              "nstitutionalteacher",
              "salespersonr", 
            ],
          },  
          {
            name: "总收益明细",
            index: "/institutionalIncomeDetail",
            icon: "",
            roles: [
              "admin",
              "generaladministrato", 
            ],
          },
          { 
            name: "结算",
            index: "/tobSettlement",
            icon: "",
            roles: [    
              "admin",
              "generaladministrato", 
            ],
          },
          {
            name: "宣传资料下载",
            index: "/tobFolderList",
            icon: "",
            roles: [
              "admin", 
              "generaladministrato", 
              "nstitutionalteacher", 
              "salespersonr",  
            ],
          },
          {
            name: "APP体验账号", 
            index: "/tobExperienceCard",
            icon: "",
            roles: [
              "admin", 
              "generaladministrato", 
            ],
          }, 
        ],
      },
      {
        name: "大数据拓客",
        index: "/callPhoneManager",
        icon: "el-icon-s-marketing",
        roles: [
          "admin",
          "generaladministrato", 
          "outboundcall",
          "nstitutionalteacher",     
          "salespersonr",  
        ],
        children: [
          {
            name: "数据统计",
            index: "/statisticsData",
            icon: "",
            roles: [
              "admin",
              "generaladministrato", 
              "outboundcall",
            ],
          },
          {
            name: "任务管理",
            index: "/taskList",
            icon: "",
            roles: [  
              "admin",
              "generaladministrato", 
            ],
          },
          {
            name: "呼叫平台",
            index: "/callPhone",
            icon: "",
            roles: [
              "admin",
              "generaladministrato", 
              "outboundcall", 
              "nstitutionalteacher",   
              "salespersonr",  
            ],
          },
          {
            name: "呼叫消费记录",
            index: "/money",
            icon: "",
            roles: [
              "admin",
              "generaladministrato", 
              "outboundcall",
            ],
          }, 
        ],
      },
      {
        name: "订单管理",
        index: "/orderManage",
        icon: "el-icon-s-claim",
        roles: [
            "admin",
            "generaladministrato",  
            "nstitutionalteacher", 
        ],
        children: [
          {
            name: "订单列表",
            index: "/orderList",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher", 
            ],
          },
          {
            name: "退费申请",
            index: "/refundApplication",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher", 
            ],
          },
        ],
      },
      {
        name: "财务流水",
        index: "/financialManage",
        icon: "el-icon-s-order",
        roles: [ 
          "admin",
          "generaladministrato",  
        ],
      },
      {
        name: "员工管理",
        index: "/employeesManage",
        icon: "el-icon-s-custom",
        roles: [
          "admin" 
        ],
      },
      {
        name: "设置",
        index: "/institutionsOption",
        icon: "el-icon-s-cooperation",
        roles: [
          "admin",
          "generaladministrato"
        ],
      },
      {
        name: "帮助中心",
        index: "/helpCenter",
        icon: "el-icon-s-claim",
        roles: [
          "admin",
          "generaladministrato",
          "nstitutionalteacher",
          "salespersonr",
        ],
        children: [
          {
            name: "操作视频",
            index: "/operateVideo",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher",
              "salespersonr",
            ],
          }, 
          {
            name: "操作手册",
            index: "/operationManual",
            icon: "",
            roles: [
              "admin",
              "generaladministrato",
              "nstitutionalteacher",
              "salespersonr",
            ],
          },  
        ],
      }, 
    ], //侧边栏列表
  },
  mutations: {
    // 添加tabs
    add_tabs(state, data) {
      this.state.openTab.push(data);
    },
    // 删除tabs
    delete_tabs(state, route) {
      let index = 0;
      for (let option of state.openTab) {
        if (option.route === route) {
          break;
        }
        index++;
      }
      this.state.openTab.splice(index, 1);
    },
    // 设置当前激活的tab
    set_active_index(state, index) {
      this.state.activeIndex = index;
    }
  },
  actions: {
  },
  modules: {
    user
  }
})
